package com.gsb.vyapar.bhagya.presentation.common.button

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.presentation.common.text.Text11SemiBold
import com.gsb.vyapar.bhagya.presentation.common.text.Text12SemiBold
import com.gsb.vyapar.bhagya.presentation.common.text.Text14SemiBold
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.white
import com.gsb.vyapar.bhagya.presentation.common.text.Text16SemiBold

@Composable
fun GVBButton(
    modifier: Modifier = Modifier,
    text: String,
    backgroundColor: Color = primary,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = modifier.height(48.dp).fillMaxWidth(),
        shape = RoundedCornerShape(25.dp),
        elevation = ButtonDefaults.elevation(),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = backgroundColor,
            contentColor = white
        )
    ) {
        Text16SemiBold(text = text, color = white)
    }
}

@Composable
fun GVBButtonReport(
    modifier: Modifier = Modifier,
    text: String,
    backgroundColor: Color = primary,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = modifier.height(48.dp).fillMaxWidth(),
        shape = RoundedCornerShape(25.dp),
        elevation = ButtonDefaults.elevation(),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = backgroundColor,
            contentColor = white
        )
    ) {
        Text14SemiBold(text = text, color = white)
    }
}

@Composable
fun GVBButtonSmall(
    modifier: Modifier = Modifier,
    text: String,
    backgroundColor: Color = primary,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = modifier.height(48.dp).width(150.dp),
        shape = RoundedCornerShape(25.dp),
        elevation = ButtonDefaults.elevation(),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = backgroundColor,
            contentColor = white
        )
    ) {
        Text16SemiBold(text = text, color = white)
    }
}

@Composable
fun GVBButtonESmall(
    modifier: Modifier = Modifier,
    text: String,
    backgroundColor: Color = primary,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = modifier.height(48.dp).width(80.dp),
        shape = RoundedCornerShape(25.dp),
        elevation = ButtonDefaults.elevation(),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = backgroundColor,
            contentColor = white
        )
    ) {
        Text11SemiBold(text = text, color = white)
    }
}

@Composable
fun GVBButtonDialog(
    modifier: Modifier = Modifier,
    text: String,
    backgroundColor: Color = primary,
    onClick: () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = modifier.height(48.dp).width(100.dp),
        shape = RoundedCornerShape(25.dp),
        elevation = ButtonDefaults.elevation(),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = backgroundColor,
            contentColor = white
        )
    ) {
        Text16SemiBold(text = text, color = white)
    }
}